module.exports = __webpack_public_path__ + "static/media/underline2.3c1e5d80.svg";